<script setup lang="ts">
defineProps({
  isSolid: {
    type: Boolean,
    default: false
  }
})

</script>

<template>
  <svg v-if="isSolid" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
       class="fill-current">
    <path
      d="M11 2C11.5523 2 12 2.44772 12 3V9C12 10.1046 11.1046 11 10 11V20C10 21.1046 9.10457 22 8 22C6.89543 22 6 21.1046 6 20V11C4.89543 11 4 10.1046 4 9V3C4 2.44772 4.44772 2 5 2C5.55228 2 6 2.44772 6 3V6.5C6 6.77614 6.22386 7 6.5 7C6.77614 7 7 6.77614 7 6.5V3C7 2.44772 7.44772 2 8 2C8.55228 2 9 2.44772 9 3V6.5C9 6.77614 9.22386 7 9.5 7C9.77614 7 10 6.77614 10 6.5V3C10 2.44772 10.4477 2 11 2Z"
      fill-rule="evenodd"
      clip-rule="evenodd"
    />
    <path
      d="M17 2C18.6569 2 20 3.34315 20 5V20C20 21.1046 19.1046 22 18 22C16.8954 22 16 21.1046 16 20V13.8252C14.8355 13.413 14 12.3057 14 11V5C14 3.34315 15.3431 2 17 2Z"
      fill-rule="evenodd"
      clip-rule="evenodd"
    />
  </svg>

  <svg v-else viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
       class="fill-current">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M3 4.5C3 3.11929 4.11929 2 5.5 2C6.0628 2 6.58217 2.18597 7 2.49982C7.41783 2.18597 7.9372 2 8.5 2C9.0628 2 9.58217 2.18597 10 2.49982C10.4178 2.18597 10.9372 2 11.5 2C12.8807 2 14 3.11929 14 4.5V9.00004C14 10.138 13.6352 11.1609 12.8921 11.901C12.3767 12.4144 11.7267 12.7446 11 12.8986V19.5C11 20.8807 9.88071 22 8.5 22C7.11929 22 6 20.8807 6 19.5V12.8868C5.29894 12.7233 4.66519 12.3849 4.15821 11.888C3.41598 11.1606 3 10.1465 3 9V4.5ZM12 4.5L12.0001 9.00004C12.0001 9.70878 11.78 10.1859 11.4807 10.484C11.1807 10.7828 10.7025 11 10 11H9V19.5C9 19.7761 8.77614 20 8.5 20C8.22386 20 8 19.7761 8 19.5V11H7C6.38236 11 5.89106 10.7859 5.55813 10.4597C5.22824 10.1363 5 9.65037 5 9V4.5C5 4.22386 5.22386 4 5.5 4C5.77614 4 6 4.22386 6 4.5V8C6 8.55228 6.44772 9 7 9C7.55228 9 8 8.55228 8 8V4.5C8 4.22386 8.22386 4 8.5 4C8.77614 4 9 4.22386 9 4.5V8C9 8.55228 9.44772 9 10 9C10.5523 9 11 8.55228 11 8V4.5C11 4.22386 11.2239 4 11.5 4C11.7761 4 12 4.22386 12 4.5Z"
    />
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M16.3844 13.5287C15.5521 12.9963 15 12.0642 15 11.0017V4.999C15 3.34149 16.3438 2 18 2C19.6569 2 21 3.34315 21 5V19.5C21 20.8807 19.8807 22 18.5 22C17.1196 22 16 20.8814 16 19.5004V14.9988C16 14.4644 16.1397 13.963 16.3844 13.5287ZM18 4C17.4471 4 17 4.44737 17 4.999V11.0017C17 11.5529 17.4466 12 18 12H19V5C19 4.44772 18.5523 4 18 4ZM19 14C18.4469 14 18 14.4473 18 14.9988V19.5004C18 19.7762 18.2235 20 18.5 20C18.7761 20 19 19.7761 19 19.5V14Z"
    />
  </svg>

</template>
